import React, { Component } from 'react';

const TIMEOUT = 20000;

export default class Banners extends Component {
    state = {
        currentBannerIndex: 0,
    };

    componentDidMount() {
        const { items } = this.props;
        if (items.length > 1) {
            this.changeBannerInterval = setInterval(this.changeBanner, TIMEOUT);
        }
    }

    componentWillUnmount() {
        clearInterval(this.changeBannerInterval);
    }

    render() {
        const { currentBannerIndex } = this.state;
        const banner = this.props.items[currentBannerIndex];

        return (
            <div style={{ width: '100%' }}>
                <a href={banner.link} target="_blank">
                    <img
                        style={{ width: '100%' }}
                        src={banner.banner.file.url}
                    />
                </a>
            </div>
        );
    }

    changeBanner = () => {
        const { items } = this.props;
        this.setState(({ currentBannerIndex }) => ({
            currentBannerIndex: (currentBannerIndex + 1) % items.length,
        }));
    };
}



// WEBPACK FOOTER //
// ./src/components/Banners.js